
import { Component, Emit, Inject, Vue } from "vue-property-decorator";
import Modal from "../../../../common/src/components/Modal.vue";
import { Container } from "inversify";
import ActionButton from "../../../../common/src/components/ActionButton.vue";
import ConferenceForm from "./ConferenceForm.vue";
import { ConferenceEditStore } from "../../stores/conference/ConferenceEditStore";
import { Confirm } from "../../../../common/src/utility/confirmations";
import { AuthStore } from "../../../../common/src/stores/AuthStore";
import { ConferenceDestroyStore } from "../../stores/conference/ConferenceDestroyStore";
import { UserEditFavoriteStore } from "../../stores/user/UserEditFavoriteStore";
import { isAdmin } from "@gsx/common";
import FavoriteBtn from "../components/FavoriteBtn.vue";
import exportToCalendar from "../../utils/downloadConferenceToCalendar";

@Component({
    components: { ConferenceForm, ActionButton, Modal, FavoriteBtn },
})
export default class EditEventModal extends Vue {
    @Inject("container") readonly container!: Container;
    authStore: AuthStore = this.container.get(AuthStore);
    editStore: ConferenceEditStore = this.container.get(ConferenceEditStore);
    destroyStore: ConferenceDestroyStore = this.container.get(ConferenceDestroyStore);
    userEditFavoriteStore: UserEditFavoriteStore = this.container.get(UserEditFavoriteStore);
    logoFile: any = null;

    mounted() {
        // mandatory for Export to calendar
        const plugin = document.createElement("script");
        plugin.setAttribute(
            "src",
            "https://cdn.jsdelivr.net/gh/nwcell/ics.js@0.2.0/ics.deps.min.js",
        );
        plugin.async = true;
        document.head.appendChild(plugin);
    }

    get values() {
        return this.editStore.data;
    }

    get errors() {
        return this.editStore.formErrors;
    }

    get isProcessing(): boolean {
        return this.editStore.isLoading || this.destroyStore.isLoading;
    }

    get canManageEvent(): boolean {
        return (
            isAdmin(this.authStore.user) ||
            this.authStore.user!.userid === this.editStore.conference!.userId
        );
    }

    get isConferenceFavorite() {
        return this.authStore.user?.favorites?.conferenceIds?.includes(
            this.editStore.conference!.conferenceid,
        );
    }

    toggleFavorites() {
        const conferenceId = this.editStore.conference!.conferenceid;
        if (this.isConferenceFavorite) {
            const indexOf =
                this.authStore.user!.favorites!.conferenceIds?.indexOf(conferenceId) || -1;
            if (indexOf >= 0) {
                this.authStore.user?.favorites?.conferenceIds?.splice(indexOf, 1);
            }
            this.userEditFavoriteStore.removeConference(conferenceId);
        } else {
            this.authStore.user?.favorites?.conferenceIds?.push(conferenceId);
            this.userEditFavoriteStore.addConference(conferenceId);
        }
    }

    downloadEventToCalendar() {
        exportToCalendar(this.editStore.conference!);
    }

    @Emit()
    submit() {
        this.editStore.logoFile.set("logo", this.logoFile);
    }

    @Emit()
    close() {
        //
    }

    @Emit()
    destroy() {
        //
    }

    async onDelete() {
        const confirm = await Confirm.fire();

        if (confirm.value) {
            this.destroy();
        }
    }
}
